/**
 *  业务相关
 */
const getDefaultState = () => {
  return {
    purchasForecast: [],
    storePriceControl: {}
  };
};
const state = getDefaultState();

const mutations = {
  setPurchasForecast(state, data) {
    state.purchasForecast = data;
  },
  movePurchasForecast(state) {
    state.purchasForecast = [];
  },
  setStorePriceControl(state, data) {
    state.storePriceControl = data;
  }
};

const actions = {
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
